// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1_cz1","title":"Header_title__1_W8A","side":"Header_side__2Phud"};